import { startCase } from 'lodash-es';
export const validateEmail = (email) => {
  if (!email) return false;
  if (/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/.test(email)) {
    return true;
  }
  return false;
};

const doThingsWithCookies = () => {
  if (!document.cookie) return;
  window.location.reload(); //to trigger the normal flow
};

const handleDeniedOrErrorState = () => {
  //instruct user to clear browsing data and grant access again.
  document.body.innerHTML =
    "<div style='width:100%;height:100%;background:#ccc;display:flex;align-items:center;justify-content:center'><div style='background:white;width:70%;padding:2rem;display:flex;flex-direction:column;justify-content:space-between;border-radius:0.5rem;'><div style='font-size:15px;font-weight:500;'>You need to clear browsing data and grant access to load lifeline. Follow the steps below to do the same.<ol style='margin-top:1rem;font-size:14px;font-weight:400;display:flex;flex-direction:column;gap:0.3rem;'><li>1.  Click the three dots located in the top-right corner of your browser window.</li><li>2.  Choose 'Clear browsing data' from the menu.</li><li>3.  In the window that appears, select the 'Advanced' tab.</li><li>4.  Click on 'Site settings' and 'hosted app data' among the options listed.</li><li>5.  Finally, click the option to clear the data.</li></ol></div><div  style='display:flex;width:100%;justify-content:flex-end;'><button style='font-size:12px;justify-content:flex-end;padding-top:0.75rem;padding-bottom:0.75rem;padding-left:2.5rem;padding-right:2.5rem;cursor:pointer;background:green;color:white;border:none;border-radius:0.5rem' id='third_party_cookie_allowed'>Done</button></div></div></div>";
  const doneBtn = document.getElementById('third_party_cookie_allowed');
  doneBtn.addEventListener('click', () => {
    window.location.reload();
  });
};

const hanldePromptState = () => {
  //initiate user action
  const graccess =
    "<div style='width:100%;height:100%;background:#e8e8e8;display:flex;align-items:center;justify-content:center'><div style='background:white;width:50%;padding:1.5rem;display:flex;flex-direction:column;justify-content:space-between;border-radius:0.5rem;'><div style='font-size:15px;font-weight:500;margin-bottom:2rem;'>Please allow storage access to lifeline.</div><div style='display:flex;width:100%;justify-content:flex-end;'><button style='font-size:12px;justify-content:flex-end;padding-top:0.75rem;padding-bottom:0.75rem;padding-left:1rem;padding-right:1rem;cursor:pointer;background:green;color:white;border:none;border-radius:0.5rem' id='third_party_cookie_access'>Grant Access</button></div></div></div>";

  document.body.innerHTML = graccess;
  const btn = document.getElementById('third_party_cookie_access');
  btn.addEventListener('click', async () => {
    try {
      await document.requestStorageAccess();
      window.location.reload();
    } catch (err) {
      // If there is an error obtaining storage access.
      handleDeniedOrErrorState();
      console.error(`Error obtaining storage access: ${err}.
                  Please sign in.`);
    }
  });
};

export const handleThirdPartyCookie = async function handleCookieAccess() {
  if (!document.hasStorageAccess) {
    doThingsWithCookies(); // This browser doesn't support the Storage Access API so let's just hope we have access!
  } else {
    const hasAccess = await document.hasStorageAccess();
    if (hasAccess) {
      doThingsWithCookies();
    } else {
      // Check whether third-party cookie access has been granted to another same-site embed
      try {
        const permission = await navigator.permissions.query({
          name: 'storage-access',
        });
        if (permission.state === 'granted') {
          await document.requestStorageAccess();
          doThingsWithCookies();
        } else if (permission.state === 'prompt') {
          // Need to call requestStorageAccess() after a user interaction
          hanldePromptState();
        } else if (permission.state === 'denied') {
          handleDeniedOrErrorState();
        }
      } catch (error) {
        console.log(`Could not access permission state. Error: ${error}`);
        doThingsWithCookies(); // Again, we'll have to hope we have access!
      }
    }
  }
};

export function convertLocalDateTimeToUtc(localDateTimeString) {
  // Get the UTC timestamp string
  const date = new Date(localDateTimeString);

  // adding 1 because getUTCMonth() method returns the month number starting from 0 for January
  // .padStart(2, '0') is used to ensure to digit day and month
  const utcDate = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1)
    .toString()
    .padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`;

  var utcTime = `${date.getUTCHours()}:${date.getUTCMinutes()}`;
  return `${utcDate}T${utcTime}`;
}

export function getStringFromSlug(slug) {
  if (!slug) return '';
  slug = slug.replaceAll('_', ' ');
  slug = slug.replace('lifeline ', '');
  const str = startCase(slug);
  return str;
}

export const getReadableTimeStamp = (ts) => {
  var dateUTC = new Date(ts);
  dateUTC = dateUTC.getTime();
  var dateIST = new Date(dateUTC).toLocaleString('en-US', {
    timeZone: 'Asia/Kolkata',
  });
  // Split the date string into its components
  const [month, day, year, hour, min, sec, meridiem] = dateIST.split(/\W+/);

  // Rearrange the components to have the date first
  const rearrangedDateIST = `${day}-${month}-${year}, ${hour}:${min} ${meridiem}`;
  return rearrangedDateIST;
};

// formatDateTimeIST: Formats a timestamp in IST as "Sep 04 2026, 12:41 PM".
// Input: "2026-09-04T07:11:00Z"
// Output: "Sep 04 2026, 12:41 PM", or "-" when the input cannot be parsed
export const formatDateTimeIST = (timestamp) => {
  if (!timestamp) return '-';

  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '-';

    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Kolkata',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).formatToParts(date);

    const part = (type) => parts.find((p) => p.type === type)?.value;
    const [month, day, year, hour, minute, dayPeriod] = [
      'month',
      'day',
      'year',
      'hour',
      'minute',
      'dayPeriod',
    ].map(part);

    if (!month || !day || !year || !hour || !minute || !dayPeriod) return '-';

    return `${month} ${day} ${year}, ${hour}:${minute} ${dayPeriod}`;
  } catch (e) {
    return '-';
  }
};

// convertToReadableDate: Converts a timestamp string to a human-readable date and time format.
// Input: "23-10-01 12:00:00"
// Output: "October 1, 2023, 12:00 PM"
export const convertToReadableDate = (timestamp) => {
  if (!timestamp || typeof timestamp !== 'string') return '-';

  try {
    const [datePart, timePart] = timestamp.split(' ');

    // Validate datePart is in YY-MM-DD format and timePart is HH:MM:SS
    const dateRegex = /^\d{2}-\d{2}-\d{2}$/;
    const timeRegex = /^\d{2}:\d{2}:\d{2}$/;

    if (!dateRegex.test(datePart) || !timeRegex.test(timePart)) {
      return '-';
    }

    const isoFormatted = `20${datePart}T${timePart}`;
    const parsedDate = new Date(isoFormatted);

    if (isNaN(parsedDate.getTime())) {
      return '-';
    }

    const formattedDate = parsedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    const formattedTime = parsedDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`;
  } catch (e) {
    return '-';
  }
};

// Helper function to get org_id from current url
export const getOrgIdFromUrl = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams?.get('org_id') || '1';
  }
  return '1';
};

export const redirectToLogin = (redirectUrl) => {
  let urlToRedirect = '/login';
  if (redirectUrl) {
    urlToRedirect = `/login?redirect_url=${redirectUrl}`;
  }
  window.location.href = urlToRedirect;
};
